import { useEffect, useState } from "react";
import { BasePageContainer } from "../../components/common";
import CustomLoader from "../../components/common/CustomLoader";
import Common360Table from "./components/common/Common360Table";
import { getDashboardData } from "../../service/ai-model.service";
import { DashboardViewType } from "../../helper/constant";
import { useAppContext } from "../../context/app.context";

const Competitor360Page = () => {

  const [supplierData, setSupplierData] = useState({ schema: null, data: [] });
  const [loading, setLoading] = useState(true);
  const { activeDashboardVersion } = useAppContext();
  useEffect(() => {
    if (activeDashboardVersion) {
      setLoading(true);
      const org = new URLSearchParams(window.location.search).get('org');
      getDashboardData({ type: DashboardViewType.COMPETITORS, org, versionId: activeDashboardVersion }).then(response => {
        if (response) {
          let { schema, data } = response;
          schema = JSON.parse(JSON.stringify(schema));
          setSupplierData({ schema, data });
        }
      }).catch(error => {
        console.error("Error fetching supplier data:", error);
      }).finally(() => setLoading(false));
    }
  }, [activeDashboardVersion]);

  const renderBusinessTable = () => {
    if (supplierData.schema && supplierData.data.length > 0) {
      return <Common360Table
        sections={supplierData.schema}
        suppliers={supplierData.data}
        title={'360Business.AI Competitors'}
        styles={{ background: 'linear-gradient(90deg, #1168C5, #439F66' }} />
    }
    return <h4 className="d-flex flex-column align-items-center justify-content-center h-100vh" >No data available</h4>
  }

  return (
    <div className="row mx-0 loginwrap">
      <BasePageContainer>
        {loading && <CustomLoader full />}
        {renderBusinessTable()}
      </BasePageContainer>
    </div>
  );
};

export default Competitor360Page;
